var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { translate } from '@utils/i18n';
import TextInput from '@components/TextInput/TextInput';
import Brushaway from '@components/Brushaway';
import Checkbox from '@components/v2/Checkbox';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import { namespace } from '../constants';
import { useUpdateLongFormTemplateMutation } from '../hooks/useLongFormTemplatesMutations';
function LongFormTemplateDetailModal({ template, onClose, territories }) {
    const [editTemplate, setEditTemplate] = useState(template);
    const updateMutation = useUpdateLongFormTemplateMutation();
    useEffect(() => {
        if (template)
            setEditTemplate(template);
    }, [template]);
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        if (editTemplate) {
            try {
                yield updateMutation.mutateAsync({
                    id: editTemplate.id,
                    data: {
                        name: editTemplate.name,
                        active: editTemplate.active,
                        territoryIds: editTemplate.territoryIds
                    }
                });
                onClose();
                return true;
            }
            catch (error) {
                return false;
            }
        }
        return false;
    });
    const handleNameChange = (event) => {
        if (editTemplate) {
            setEditTemplate(Object.assign(Object.assign({}, editTemplate), { name: event.target.value }));
        }
    };
    const handleActiveChange = (checked) => {
        if (editTemplate) {
            setEditTemplate(Object.assign(Object.assign({}, editTemplate), { active: checked }));
        }
    };
    const handleTerritoryChange = (values) => {
        if (editTemplate) {
            setEditTemplate(Object.assign(Object.assign({}, editTemplate), { territoryIds: values }));
        }
    };
    return (React.createElement(Brushaway, { open: template !== null, title: translate('detail.title', { namespace }), isForm: true, onClose: onClose, onSubmit: handleSubmitForm },
        React.createElement("div", null,
            React.createElement("div", { className: "formSection" },
                React.createElement(TextInput, { id: "template-name", value: (editTemplate === null || editTemplate === void 0 ? void 0 : editTemplate.name) || '', label: translate('detail.name_label', { namespace }), onChange: handleNameChange, placeholder: translate('detail.name_placeholder', { namespace }) }),
                territories.length > 0 && (React.createElement("div", { className: "mt-3" },
                    React.createElement(SelectInput, { label: translate('detail.territories_label', { namespace }), options: territories, values: (editTemplate === null || editTemplate === void 0 ? void 0 : editTemplate.territoryIds) || [], onMultiChange: handleTerritoryChange, multiple: true, showSearch: true, displayMode: "labels", className: "mb-1" }),
                    React.createElement("small", { className: "note-section" },
                        React.createElement("i", { className: "fa fa-light fa-circle-info mr-1" }),
                        translate('detail.territories_hint', { namespace })))),
                React.createElement(Checkbox, { id: "template-active", className: "mt-3", checked: (editTemplate === null || editTemplate === void 0 ? void 0 : editTemplate.active) || false, onChange: handleActiveChange, label: translate('detail.active_label', { namespace }) })))));
}
export default LongFormTemplateDetailModal;
